import ChatRoomItem from './ChatRoomItem';

export default ChatRoomItem;
